const capitalize = (str: string): string => {
  if (!str) return '';
  str = str.toLowerCase();
  if (str.length >= 1) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};

export const fName = (
  firstName: string | null,
  middleName: string | null,
  lastName: string | null
): string => {
  if (!firstName) return ''; // trying to catch a weird error
  firstName = capitalize(firstName);
  if (middleName) firstName += ' ' + capitalize(middleName);
  if (lastName) firstName += ' ' + capitalize(lastName);

  return firstName;
};

export const formatGeographyName = (input: string): string => {
  return input
    .trim() // remove leading/trailing whitespace
    .replace(/\s+/g, ' ') // collapse multiple spaces
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
